export const fontsList = [
  {
    fontName: 'Old Italic Text',
    fontLower: '𐌀 𐌁 𐌂 𐌃 𐌄 𐌅 Ᏽ 𐋅 𐌉 Ꮭ 𐌊 𐌋 𐌌 𐌍 Ꝋ 𐌐 𐌒 𐌓 𐌔 𐌕 𐌵 ᕓ Ꮤ 𐋄 𐌙 Ɀ',
    fontUpper: '𐌀 𐌁 𐌂 𐌃 𐌄 𐌅 Ᏽ 𐋅 𐌉 Ꮭ 𐌊 𐌋 𐌌 𐌍 Ꝋ 𐌐 𐌒 𐌓 𐌔 𐌕 𐌵 ᕓ Ꮤ 𐋄 𐌙 Ɀ',
    fontDigits: 'Ꝋ ᛑ ᘖ ᙣ ᔦ ᔕ ᑳ ᒣ ზ ᖗ',
  },
  {
    fontName: 'Bubbles',
    fontLower: 'ⓐ ⓑ ⓒ ⓓ ⓔ ⓕ ⓖ ⓗ ⓘ ⓙ ⓚ ⓛ ⓜ ⓝ ⓞ ⓟ ⓠ ⓡ ⓢ ⓣ ⓤ ⓥ ⓦ ⓧ ⓨ ⓩ',
    fontUpper: 'Ⓐ Ⓑ Ⓒ Ⓓ Ⓔ Ⓕ Ⓖ Ⓗ Ⓘ Ⓙ Ⓚ Ⓛ Ⓜ Ⓝ Ⓞ Ⓟ Ⓠ Ⓡ Ⓢ Ⓣ Ⓤ Ⓥ Ⓦ Ⓧ Ⓨ Ⓩ',
    fontDigits: '⓪ ① ② ③ ④ ⑤ ⑥ ⑦ ⑧ ⑨',
  },
  {
    fontName: 'BubbleBlack',
    fontLower: '🅐 🅑 🅒 🅓 🅔 🅕 🅖 🅗 🅘 🅙 🅚 🅛 🅜 🅝 🅞 🅟 🅠 🅡 🅢 🅣 🅤 🅥 🅦 🅧 🅨 🅩',
    fontUpper: '🅐 🅑 🅒 🅓 🅔 🅕 🅖 🅗 🅘 🅙 🅚 🅛 🅜 🅝 🅞 🅟 🅠 🅡 🅢 🅣 🅤 🅥 🅦 🅧 🅨 🅩',
    fontDigits: '⓿ ➊ ➋ ➌ ➍ ➎ ➏ ➐ ➑ ➒',
  },
  {
    fontName: 'Parenthesis',
    fontLower: '⒜ ⒝ ⒞ ⒟ ⒠ ⒡ ⒢ ⒣ ⒤ ⒥ ⒦ ⒧ ⒨ ⒩ ⒪ ⒫ ⒬ ⒭ ⒮ ⒯ ⒰ ⒱ ⒲ ⒳ ⒴ ⒵',
    fontUpper: '⒜ ⒝ ⒞ ⒟ ⒠ ⒡ ⒢ ⒣ ⒤ ⒥ ⒦ ⒧ ⒨ ⒩ ⒪ ⒫ ⒬ ⒭ ⒮ ⒯ ⒰ ⒱ ⒲ ⒳ ⒴ ⒵',
    fontDigits: '0 ⑴ ⑵ ⑶ ⑷ ⑸ ⑹ ⑺ ⑻ ⑼',
  },
  {
    fontName: 'SuperScript',
    fontLower: 'ᵃ ᵇ ᶜ ᵈ ᵉ ᶠ ᵍ ʰ ⁱ ʲ ᵏ ˡ ᵐ ⁿ ᵒ ᵖ q ʳ ˢ ᵗ ᵘ ᵛ ʷ ˣ ʸ ᶻ',
    fontUpper: 'ᴬ ᴮ ᶜ ᴰ ᴱ ᶠ ᴳ ᴴ ᴵ ᴶ ᴷ ᴸ ᴹ ᴺ ᴼ ᴾ Q ᴿ ˢ ᵀ ᵁ ⱽ ᵂ ˣ ʸ ᶻ',
    fontDigits: '⁰ ¹ ² ³ ⁴ ⁵ ⁶ ⁷ ⁸ ⁹',
  },
  {
    fontName: 'FullWidth',
    fontLower: 'ａ ｂ ｃ ｄ ｅ ｆ ｇ ｈ ｉ ｊ ｋ ｌ ｍ ｎ ｏ ｐ ｑ ｒ ｓ ｔ ｕ ｖ ｗ ｘ ｙ ｚ',
    fontUpper: 'Ａ Ｂ Ｃ Ｄ Ｅ Ｆ Ｇ Ｈ Ｉ Ｊ Ｋ Ｌ Ｍ Ｎ Ｏ Ｐ Ｑ Ｒ Ｓ Ｔ Ｕ Ｖ Ｗ Ｘ Ｙ Ｚ',
    fontDigits: '０ １ ２ ３ ４ ５ ６ ７ ８ ９',
  },
  {
    fontName: 'MathBold',
    fontLower: '𝐚 𝐛 𝐜 𝐝 𝐞 𝐟 𝐠 𝐡 𝐢 𝐣 𝐤 𝐥 𝐦 𝐧 𝐨 𝐩 𝐪 𝐫 𝐬 𝐭 𝐮 𝐯 𝐰 𝐱 𝐲 𝐳',
    fontUpper: '𝐀 𝐁 𝐂 𝐃 𝐄 𝐅 𝐆 𝐇 𝐈 𝐉 𝐊 𝐋 𝐌 𝐍 𝐎 𝐏 𝐐 𝐑 𝐒 𝐓 𝐔 𝐕 𝐖 𝐗 𝐘 𝐙',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'MathItalic',
    fontLower: '𝒂 𝒃 𝒄 𝒅 𝒆 𝒇 𝒈 𝒉 𝒊 𝒋 𝒌 𝒍 𝒎 𝒏 𝒐 𝒑 𝒒 𝒓 𝒔 𝒕 𝒖 𝒗 𝒘 𝒙 𝒚 𝒛',
    fontUpper: '𝑨 𝑩 𝑪 𝑫 𝑬 𝑭 𝑮 𝑯 𝑰 𝑱 𝑲 𝑳 𝑴 𝑵 𝑶 𝑷 𝑸 𝑹 𝑺 𝑻 𝑼 𝑽 𝑾 𝑿 𝒀 𝒁',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'MathSans',
    fontLower: '𝖺 𝖻 𝖼 𝖽 𝖾 𝖿 𝗀 𝗁 𝗂 𝗃 𝗄 𝗅 𝗆 𝗇 𝗈 𝗉 𝗊 𝗋 𝗌 𝗍 𝗎 𝗏 𝗐 𝗑 𝗒 𝗓',
    fontUpper: '𝖠 𝖡 𝖢 𝖣 𝖤 𝖥 𝖦 𝖧 𝖨 𝖩 𝖪 𝖫 𝖬 𝖭 𝖮 𝖯 𝖰 𝖱 𝖲 𝖳 𝖴 𝖵 𝖶 𝖷 𝖸 𝖹',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'MathSansItalic',
    fontLower: '𝘢 𝘣 𝘤 𝘥 𝘦 𝘧 𝘨 𝘩 𝘪 𝘫 𝘬 𝘭 𝘮 𝘯 𝘰 𝘱 𝘲 𝘳 𝘴 𝘵 𝘶 𝘷 𝘸 𝘹 𝘺 𝘻',
    fontUpper: '𝘈 𝘉 𝘊 𝘋 𝘌 𝘍 𝘎 𝘏 𝘐 𝘑 𝘒 𝘓 𝘔 𝘕 𝘖 𝘗 𝘘 𝘙 𝘚 𝘛 𝘜 𝘝 𝘞 𝘟 𝘠 𝘡',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'MathSansBold',
    fontLower: '𝗮 𝗯 𝗰 𝗱 𝗲 𝗳 𝗴 𝗵 𝗶 𝗷 𝗸 𝗹 𝗺 𝗻 𝗼 𝗽 𝗾 𝗿 𝘀 𝘁 𝘂 𝘃 𝘄 𝘅 𝘆 𝘇',
    fontUpper: '𝗔 𝗕 𝗖 𝗗 𝗘 𝗙 𝗚 𝗛 𝗜 𝗝 𝗞 𝗟 𝗠 𝗡 𝗢 𝗣 𝗤 𝗥 𝗦 𝗧 𝗨 𝗩 𝗪 𝗫 𝗬 𝗭',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'MathSansBoldItalic',
    fontLower: '𝙖 𝙗 𝙘 𝙙 𝙚 𝙛 𝙜 𝙝 𝙞 𝙟 𝙠 𝙡 𝙢 𝙣 𝙤 𝙥 𝙦 𝙧 𝙨 𝙩 𝙪 𝙫 𝙬 𝙭 𝙮 𝙯',
    fontUpper: '𝘼 𝘽 𝘾 𝘿 𝙀 𝙁 𝙂 𝙃 𝙄 𝙅 𝙆 𝙇 𝙈 𝙉 𝙊 𝙋 𝙌 𝙍 𝙎 𝙏 𝙐 𝙑 𝙒 𝙓 𝙔 𝙕',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Fraktur',
    fontLower: '𝔞 𝔟 𝔠 𝔡 𝔢 𝔣 𝔤 𝔥 𝔦 𝔧 𝔨 𝔩 𝔪 𝔫 𝔬 𝔭 𝔮 𝔯 𝔰 𝔱 𝔲 𝔳 𝔴 𝔵 𝔶 𝔷',
    fontUpper: '𝔄 𝔅 ℭ 𝔇 𝔈 𝔉 𝔊 ℌ ℑ 𝔍 𝔎 𝔏 𝔐 𝔑 𝔒 𝔓 𝔔 ℜ 𝔖 𝔗 𝔘 𝔙 𝔚 𝔛 𝔜 ℨ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'FrakturBold',
    fontLower: '𝖆 𝖇 𝖈 𝖉 𝖊 𝖋 𝖌 𝖍 𝖎 𝖏 𝖐 𝖑 𝖒 𝖓 𝖔 𝖕 𝖖 𝖗 𝖘 𝖙 𝖚 𝖛 𝖜 𝖝 𝖞 𝖟',
    fontUpper: '𝕬 𝕭 𝕮 𝕯 𝕰 𝕱 𝕲 𝕳 𝕴 𝕵 𝕶 𝕷 𝕸 𝕹 𝕺 𝕻 𝕼 𝕽 𝕾 𝕿 𝖀 𝖁 𝖂 𝖃 𝖄 𝖅',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Russian',
    fontLower: 'а б c д ё f g н ї j к г ѫ п ѳ p ф я $ т ц ѵ щ ж ч з',
    fontUpper: 'А Б C Д Є F G H Ї J К Г Ѫ Й Ѳ P Ф Я $ T Ц Ѵ Ш Ж Ч З',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Japanese',
    fontLower: '卂 乃 匚 ᗪ 乇 千 Ꮆ 卄 丨 ﾌ Ҝ ㄥ 爪 几 ㄖ 卩 Ɋ 尺 丂 ㄒ ㄩ ᐯ 山 乂 ㄚ 乙',
    fontUpper: '卂 乃 匚 ᗪ 乇 千 Ꮆ 卄 丨 ﾌ Ҝ ㄥ 爪 几 ㄖ 卩 Ɋ 尺 丂 ㄒ ㄩ ᐯ 山 乂 ㄚ 乙',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Arabic',
    fontLower: 'ค ๒ ς ๔ є Ŧ ﻮ ђ เ ן к l ๓ ภ ๏ ק ợ г ร t ย ש ฬ ץ א z',
    fontUpper: 'ค ๒ ς ๔ є Ŧ ﻮ ђ เ ן к l ๓ ภ ๏ ק ợ г ร t ย ש ฬ ץ א z',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Fairy',
    fontLower: 'Ꮧ Ᏸ ፈ Ꮄ Ꮛ Ꭶ Ꮆ Ꮒ Ꭵ Ꮰ Ꮶ Ꮭ Ꮇ Ꮑ Ꭷ Ꭾ Ꭴ Ꮢ Ꮥ Ꮦ Ꮼ Ꮙ Ꮗ ጀ Ꭹ ፚ',
    fontUpper: 'Ꮧ Ᏸ ፈ Ꮄ Ꮛ Ꭶ Ꮆ Ꮒ Ꭵ Ꮰ Ꮶ Ꮭ Ꮇ Ꮑ Ꭷ Ꭾ Ꭴ Ꮢ Ꮥ Ꮦ Ꮼ Ꮙ Ꮗ ጀ Ꭹ ፚ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Wizard',
    fontLower: 'ǟ ɮ ƈ ɖ ɛ ʄ ɢ ɦ ɨ ʝ ӄ ʟ ʍ ռ օ ք զ ʀ ֆ ȶ ʊ ʋ ա Ӽ ʏ ʐ',
    fontUpper: 'ǟ ɮ ƈ ɖ ɛ ʄ ɢ ɦ ɨ ʝ ӄ ʟ ʍ ռ օ ք զ ʀ ֆ ȶ ʊ ʋ ա Ӽ ʏ ʐ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Monospace',
    fontLower: '𝚊 𝚋 𝚌 𝚍 𝚎 𝚏 𝚐 𝚑 𝚒 𝚓 𝚔 𝚕 𝚖 𝚗 𝚘 𝚙 𝚚 𝚛 𝚜 𝚝 𝚞 𝚟 𝚠 𝚡 𝚢 𝚣',
    fontUpper: '𝙰 𝙱 𝙲 𝙳 𝙴 𝙵 𝙶 𝙷 𝙸 𝙹 𝙺 𝙻 𝙼 𝙽 𝙾 𝙿 𝚀 𝚁 𝚂 𝚃 𝚄 𝚅 𝚆 𝚇 𝚈 𝚉',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'ScriptBold',
    fontLower: '𝓪 𝓫 𝓬 𝓭 𝓮 𝓯 𝓰 𝓱 𝓲 𝓳 𝓴 𝓵 𝓶 𝓷 𝓸 𝓹 𝓺 𝓻 𝓼 𝓽 𝓾 𝓿 𝔀 𝔁 𝔂 𝔃',
    fontUpper: '𝓐 𝓑 𝓒 𝓓 𝓔 𝓕 𝓖 𝓗 𝓘 𝓙 𝓚 𝓛 𝓜 𝓝 𝓞 𝓟 𝓠 𝓡 𝓢 𝓣 𝓤 𝓥 𝓦 𝓧 𝓨 𝓩',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'DoubleStruck',
    fontLower: '𝕒 𝕓 𝕔 𝕕 𝕖 𝕗 𝕘 𝕙 𝕚 𝕛 𝕜 𝕝 𝕞 𝕟 𝕠 𝕡 𝕢 𝕣 𝕤 𝕥 𝕦 𝕧 𝕨 𝕩 𝕪 𝕫',
    fontUpper: '𝔸 𝔹 ℂ 𝔻 𝔼 𝔽 𝔾 ℍ 𝕀 𝕁 𝕂 𝕃 𝕄 ℕ 𝕆 ℙ ℚ ℝ 𝕊 𝕋 𝕌 𝕍 𝕎 𝕏 𝕐 ℤ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Squared',
    fontLower: '🄰 🄱 🄲 🄳 🄴 🄵 🄶 🄷 🄸 🄹 🄺 🄻 🄼 🄽 🄾 🄿 🅀 🅁 🅂 🅃 🅄 🅅 🅆 🅇 🅈 🅉',
    fontUpper: '🄰 🄱 🄲 🄳 🄴 🄵 🄶 🄷 🄸 🄹 🄺 🄻 🄼 🄽 🄾 🄿 🅀 🅁 🅂 🅃 🅄 🅅 🅆 🅇 🅈 🅉',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Funky',
    fontLower: 'α в ¢ ∂ є ƒ g н ι נ к ℓ м η σ ρ q я ѕ т υ ν ω χ у z',
    fontUpper: 'α в ¢ ∂ є ƒ g н ι נ к ℓ м η σ ρ q я ѕ т υ ν ω χ у z',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Acute',
    fontLower: 'á b ć d é f ǵ h í j ḱ ĺ ḿ ń ő ṕ q ŕ ś t ú v ẃ x ӳ ź',
    fontUpper: 'Á B Ć D É F Ǵ H í J Ḱ Ĺ Ḿ Ń Ő Ṕ Q Ŕ ś T Ű V Ẃ X Ӳ Ź',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'RockDots',
    fontLower: 'ä ḅ ċ ḋ ë ḟ ġ ḧ ï j ḳ ḷ ṁ ṅ ö ṗ q ṛ ṡ ẗ ü ṿ ẅ ẍ ÿ ż',
    fontUpper: 'Ä Ḅ Ċ Ḋ Ё Ḟ Ġ Ḧ Ї J Ḳ Ḷ Ṁ Ṅ Ö Ṗ Q Ṛ Ṡ Ṫ Ü Ṿ Ẅ Ẍ Ÿ Ż',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Stroked',
    fontLower: 'Ⱥ ƀ ȼ đ ɇ f ǥ ħ ɨ ɉ ꝁ ł m n ø ᵽ ꝗ ɍ s ŧ ᵾ v w x ɏ ƶ',
    fontUpper: 'Ⱥ Ƀ Ȼ Đ Ɇ F Ǥ Ħ Ɨ Ɉ Ꝁ Ł M N Ø Ᵽ Ꝗ Ɍ S Ŧ ᵾ V W X Ɏ Ƶ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Inverted',
    fontLower: 'ɐ q ɔ p ǝ ɟ ƃ ɥ ı ɾ ʞ ן ɯ u o d b ɹ s ʇ n ʌ ʍ x ʎ z',
    fontUpper: '∀ ᗺ Ɔ ᗡ Ǝ Ⅎ ⅁ H I ſ ꓘ ˥ W N O Ԁ ტ ᴚ S ⊥ ∩ Λ M X ⅄ Z',
    fontDigits: '0ƖᘔƐ߈95ㄥ86',
  },
  {
    fontName: 'Lines Font',
    fontLower: 'a̳̿͟͞ b̳̿͟͞ c̳̿͟͞ d̳̿͟͞ e̳̿͟͞ f̳̿͟͞ g̳̿͟͞ h̳̿͟͞ i̳̿͟͞ j̳̿͟͞ k̳̿͟͞ l̳̿͟͞ m̳̿͟͞ n̳̿͟͞ o̳̿͟͞ p̳̿͟͞ q̳̿͟͞ r̳̿͟͞ s̳̿͟͞ t̳̿͟͞ u̳̿͟͞ v̳̿͟͞ w̳̿͟͞ x̳̿͟͞ y̳̿͟͞ z̳̿͟͞',
    fontUpper: 'A̳̿͟͞ B̳̿͟͞ C̳̿͟͞ D̳̿͟͞ E̳̿͟͞ F̳̿͟͞ G̳̿͟͞ H̳̿͟͞ I̳̿͟͞ J̳̿͟͞ K̳̿͟͞ L̳̿͟͞ M̳̿͟͞ N̳̿͟͞ O̳̿͟͞ P̳̿͟͞ Q̳̿͟͞ R̳̿͟͞ S̳̿͟͞ T̳̿͟͞ U̳̿͟͞ V̳̿͟͞ W̳̿͟͞ X̳̿͟͞ Y̳̿͟͞ Z̳̿͟͞',
    fontDigits: '0̳̿͟͞ 1̳̿͟͞ 2̳̿͟͞ 3̳̿͟͞ 4̳̿͟͞ 5̳̿͟͞ 6̳̿͟͞ 7̳̿͟͞ 8̳̿͟͞ 9̳̿͟͞',
  },
  {
    fontName: 'Mix1',
    fontLower: '𝐚 ๒ Ć 𝓭 𝑒 ⓕ 𝕘 𝓱 Ɨ Ｊ Ⓚ ᒪ м 𝐍 Ø 卩 q я 丂 𝐓 ย ｖ 𝔀 x 𝔂 𝓩',
    fontUpper: '𝐀 β ⓒ 𝓭 𝑒 ⓕ ᵍ ⓗ Ꭵ ן ᵏ 𝕃 ｍ ⓝ 𝓸 Ƥ ℚ ⓡ 𝓼 Ｔ 𝓾 v 𝓌 ⓧ ץ Ż',
    fontDigits: '０ ➀ ❷ ➂ ４ ❺ ６ ❼ ➇ ❾',
  },

  {
    fontName: 'Mix2',
    fontLower: '𝐚 ᵇ ¢ ᗪ ｅ ғ g ⓗ 𝕀 ｊ Ҝ ᒪ м ภ 𝑜 ρ 𝓺 я ᔕ 丅 𝓊 𝐯 Ŵ ⓧ Ⓨ ℤ',
    fontUpper: 'ａ ｂ 𝔠 ᵈ έ 𝔽 g ⓗ 𝓘 Ⓙ Ќ l 𝓂 ή 𝐎 𝓟 𝕢 𝔯 𝐒 𝕥 𝓊 ν ᗯ Ⓧ у Ż',
    fontDigits: '０ ❶ ２ ３ ４ ５ ６ ７ ➇ ❾',
  },
  {
    fontName: 'Mix3',
    fontLower: 'α 𝕓 匚 Đ ⓔ 𝐟 Ꮆ ｈ 𝒾 ʲ к ⓛ Μ ℕ ㄖ ᑭ ᵠ ℝ 丂 𝐭 ᵘ 𝓋 ώ χ 𝕐 𝔃',
    fontUpper: 'ᗩ 𝐁 Ｃ 𝒹 𝒆 𝔣 𝓰 𝒽 𝒾 ڶ ķ 𝔩 ᗰ 𝓃 𝓸 𝐏 Ω ｒ ｓ ｔ υ 𝓥 ώ Ж Ƴ z',
    fontDigits: '０ １ ❷ ３ ❹ ➄ ６ ７ ➇ ❾',
  },
  {
    fontName: 'Handwrite',
    fontLower: '𝒶 𝒷 𝒸 𝒹 𝑒 𝒻 𝑔 𝒽 𝒾 𝒿 𝓀 𝓁 𝓂 𝓃 𝑜 𝓅 𝓆 𝓇 𝓈 𝓉 𝓊 𝓋 𝓌 𝓍 𝓎 𝓏',
    fontUpper: '𝒜 𝐵 𝒞 𝒟 𝐸 𝐹 𝒢 𝐻 𝐼 𝒥 𝒦 𝐿 𝑀 𝒩 𝒪 𝒫 𝒬 𝑅 𝒮 𝒯 𝒰 𝒱 𝒲 𝒳 𝒴 𝒵',
    fontDigits: '',
  },
  {
    fontName: 'UpAndDown',
    fontLower: 'ₐ b c d ₑ f g ₕ ᵢ ⱼ ₖ ₗ ₘ ₙ ₒ ₚ q ᵣ ₛ ₜ ᵤ ᵥ w ₓ y z',
    fontUpper: 'ₐ B C D ₑ F G ₕ ᵢ ⱼ ₖ ₗ ₘ ₙ ₒ ₚ Q ᵣ ₛ ₜ ᵤ ᵥ W ₓ Y Z',
    fontDigits: '₀ ₁ ₂ ₃ ₄ ₅ ₆ ₇ ₈ ₉',
  },
  {
    fontName: 'DoubleStroke',
    fontLower: '₳ ฿ ₵ Đ Ɇ ₣ ₲ Ⱨ ł J ₭ Ⱡ ₥ ₦ Ø ₱ Q Ɽ ₴ ₮ Ʉ V ₩ Ӿ Ɏ Ⱬ',
    fontUpper: '₳ ฿ ₵ Đ Ɇ ₣ ₲ Ⱨ ł J ₭ Ⱡ ₥ ₦ Ø ₱ Q Ɽ ₴ ₮ Ʉ V ₩ Ӿ Ɏ Ⱬ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'FutureGreek',
    fontLower: 'Λ B ᄃ D Σ F G Ή I J K ᄂ M П Ө P Q Я Ƨ Ƭ Ц V Щ X Y Z',
    fontUpper: 'Λ B ᄃ D Σ F G Ή I J K ᄂ M П Ө P Q Я Ƨ Ƭ Ц V Щ X Y Z',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'European',
    fontLower: 'å ß ¢ Ð ê £ g h ï j k l m ñ ð þ q r § † µ v w x ¥ z',
    fontUpper: 'Ä ß Ç Ð È £ G H Ì J K L M ñ Ö þ Q R § † Ú V W × ¥ Z',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'AsiaOne',
    fontLower: 'ﾑ 乃 ᄃ り 乇 ｷ ム ん ﾉ ﾌ ズ ﾚ ﾶ 刀 の ｱ ゐ 尺 丂 ｲ ひ √ W ﾒ ﾘ 乙',
    fontUpper: 'ﾑ 乃 ᄃ り 乇 ｷ ム ん ﾉ ﾌ ズ ﾚ ﾶ 刀 の ｱ ゐ 尺 丂 ｲ ひ √ W ﾒ ﾘ 乙',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Yatagan',
    fontLower: 'ค ๖ ¢ ໓ ē f ງ h i ว k l ๓ ຖ ໐ p ๑ r Ş t น ง ຟ x ฯ ຊ',
    fontUpper: 'ค ๖ ¢ ໓ ē f ງ h i ว k l ๓ ຖ ໐ p ๑ r Ş t น ง ຟ x ฯ ຊ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'CometTail',
    fontLower: 'ǎ̴̯̀͠ b̸̼̋͛̑͆̈́͗̿̅ c̵̛̥͊ d̶̡̲̗̼̮̤̤̳̲͖͓͍͔͓̓̎̽́̽̏̐͂̆͆͘͘͘ ë̸͓̮͉͈͇͍̖͎̩̞͈́́́̋̇̾͋̈́̾͆͑͘͘͜͠͝ f̵̢̻͈̫̬̻͔̘̞͈̆̇̍̈̌͊ͅ ǧ̷̡̟̲̹̩̱͉̮̭͇͚̮̖̟̽̓͊̔̓̕ ḥ̸̨̧̗̮̖̽̂̓̀̍̋͋́̅̃͘͜͝ i̶̡̹͈͎̳̞͙͖̾̂̀͑̀͆̑̓̽̉͐͘͘ͅ j̵̬̺̭̼̺̫̦͚̬̼͚͙̰̭̐̐ͅ k̵̘̺̦͉͖̪̪͖͉͊̆̔́̈́̍̃̈́͒̂̑̀̚͜͝ l̶̬̞͎̖͉̹̝͕̝͖̣̉͆ m̵̢͕̫̓̔͑̊̈ ǹ̷̨͍̮̥̹̘͙̗̻̬̬̜̥̮̃̒̈́̽͗̿̍̄̂̏͆͠͝ ŏ̸̡̼̺̫̥̻͈̞̍͆̏̓́͜͝ͅ p̴̩͙̺̩͓̣͈͖̎ͅ q̶̡̛̥̫͓̩̫͇̥̋͊̇̄͐̈́̓͠ r̵̡͕͈͚͍͍̼͕̍̀̈́̽̎̍͗̍́̏̚͜͠ s̴̹̀̎̇͗̍͗̾̋̏̈͐͒̕͠͠ͅ t̸̫̫̤͕̳̻̰̣̭́̌̉͝ͅ u̷̬̩̰̫͕̘͎̔́̃̄̍͋̓ ṽ̵͇̟̺̣͓̰̭̲̼̻̪̩̰͒̓̿̄̾̔̊͝ͅ ẃ̸̝̝̰͋͒ x̵̢̝̹̘͖͖̜̩̝͗̽́̑͗͋ y̶͔͗ z̷̛̻̤̯̥̝͎̯͚̹͇͗̆̄̈́̅̎̓̿̎͋́̅̈́̚͜',
    fontUpper: 'Ą̵̺̰̻̻͔͇͓̈́̓͛̏̈́͌͋̄̑͆̏ B̶̨̛̺̤̱̾̀́̋̔̆̏̎͘͘ C̴̀͐ͅ Ḑ̷̮̳̣̟͉͋͗̓̕͜ Ȩ̸̪̯̗̘̥̣̲̣̣͍͚͙̥̩́̀̈̆͑ F̵̜̜͎͉̯̜̓͂ G̶̺̥̎̄͌͑͂̔̏̓̂́̈́͜͝͝͝͝ͅ Ḩ̵̛̘̤͙͔̝̫̖̻̦̞͙̺̅̿͘͝ I̸̺̺͎̰̥̜̯̼̮̰͖̜͂͆̿̈́̿̔ Ĵ̸͔̣̮̤̝̥̆̏͋͒͝ K̵̢̛̛͉̳̫͔̺̱̗̫̽̉́͋̾́͂͛ L̷͖͈̓͌̎̉͒͗͂̓̌̚͝ M̶̧͚̪͉̯̜̰͎̘̀͋̇̀͗̍́͆̑̏͂̿̊̚ N̸̡̧͕͙̼̻̳̦̪̞̯͎̦͓̏̒͌͑͒͊̾͌̑̅̕͝ͅ O̵̧̗͕̹̼̦̗̮̱̝͆͊́́̈̿̋ͅ P̷̛̛̛̩̺͇̊̅̍͂͗͑͐̎̂̏̐̐ Q̷̡̠̝͚̼̘̜̜̠͍͓̎̒̀̿͋̅̄̀̿̄̏͠ͅ Ŗ̷͇̙̰̭̪̟̺̲̜̹͔̎̍́ͅ Ś̸͙̺̥̰̯͙̭͆̏͂ T̷̡̧̬̲̭̦̘̩̊̉͛̓̓̌͌̕ U̴̡̢̱̳̳͓̗͔̮̔͜͜͜ V̵̧͖͙̲̯̞͇̲͔̤͊̔͌͂͆͑́́̑͒͝ W̵̰̻͍̉̔̅̀̐͐͒͆̒̚ X̶̨̢̗͍̪͚͍̱̭̣̰̳̠͌̓͌̅͆̈́̊̅̓̿͠ Ý̴̥͙̘̇̈́̇̃͒̿́͘͘͝͝ͅ Z̵̥̼̐̀̐́̅̀̈͆̓͒́̕̚͠',
    fontDigits: '0̴̛̫̪̯̺̭̻̭͖̲̮͓̋̉̀̑͗̃̌͠ͅ 1̵̡̱̟͇̙͕͎̻̖̌ 2̸̨̨̢̛̝̣̝̻̺͖̳̹̦̼̖̩̎̾̈́̄́̊̕͘͝ 3̵̧͔̖̪̗̺̺͙̭̮̘̂̀̂̒͂͌͑̈́̏̈̒́͛͜͠ 4̴̧̢͙̫͖͕̩̭̞̗̲̞̮̩̌̈́͆͑̏̈́̏̐̇̈́ 5̷̧̡̛̭̞͙͓̰͔̞̠̗̫͊̇̐͆̋̀̑͗̇̚͘͝͠͠ 6̴̧̡̢̝̼͈͔̙̪͔͉̻͑̔̓͜͝ͅ 7̵̡̰̞̞͙͎͖̪̲̻̮̈́̈̔̃́̀̔̍̌̈́̌̀͒ 8̶͙̣̲̟̞̺̗̤̰͓̳̼̽͜ 9̴̛̳̟̤̯̤̮̞̩̦͐̎͂̐̏̈́̒̚͜',
    className: 'high',
  },
  {
    fontName: 'MonoUpper',
    fontLower: 'ᴀ ʙ ᴄ ᴅ ᴇ ꜰ ɢ ʜ ɪ ᴊ ᴋ ʟ ᴍ ɴ ᴏ ᴘ Q ʀ ꜱ ᴛ ᴜ ᴠ ᴡ x ʏ ᴢ',
    fontUpper: 'ᴀ ʙ ᴄ ᴅ ᴇ ꜰ ɢ ʜ ɪ ᴊ ᴋ ʟ ᴍ ɴ ᴏ ᴘ Q ʀ ꜱ ᴛ ᴜ ᴠ ᴡ x ʏ ᴢ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'TinySquare',
    fontLower: '🅰 🅱 🅲 🅳 🅴 🅵 🅶 🅷 🅸 🅹 🅺 🅻 🅼 🅽 🅾 🅿 🆀 🆁 🆂 🆃 🆄 🆅 🆆 🆇 🆈 🆉',
    fontUpper: '🅰 🅱 🅲 🅳 🅴 🅵 🅶 🅷 🅸 🅹 🅺 🅻 🅼 🅽 🅾 🅿 🆀 🆁 🆂 🆃 🆄 🆅 🆆 🆇 🆈 🆉',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Devlish',
    fontLower: 'α Ⴆ ƈ ԃ ҽ ϝ ɠ ԋ ι ʝ ƙ ʅ ɱ ɳ σ ρ ϙ ɾ ʂ ƚ υ ʋ ɯ x ყ ȥ',
    fontUpper: 'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Brackets1',
    fontLower:
      '【a】 【b】 【c】 【d】 【e】 【f】 【g】 【h】 【i】 【j】 【k】 【l】 【m】 【n】 【o】 【p】 【q】 【r】 【s】 【t】 【u】 【v】 【w】 【x】 【y】 【z】',
    fontUpper:
      '【A】 【B】 【C】 【D】 【E】 【F】 【G】 【H】 【I】 【J】 【K】 【L】 【M】 【N】 【O】 【P】 【Q】 【R】 【S】 【T】 【U】 【V】 【W】 【X】 【Y】 【Z】',
    fontDigits: '【0】 【1】 【2】 【3】 【4】 【5】 【6】 【7】 【8】 【9】',
  },
  {
    fontName: 'Brackets2',
    fontLower:
      '『a』 『b』 『c』 『d』 『e』 『f』 『g』 『h』 『i』 『j』 『k』 『l』 『m』 『n』 『o』 『p』 『q』 『r』 『s』 『t』 『u』 『v』 『w』 『x』 『y』 『z』',
    fontUpper:
      '『A』 『B』 『C』 『D』 『E』 『F』 『G』 『H』 『I』 『J』 『K』 『L』 『M』 『N』 『O』 『P』 『Q』 『R』 『S』 『T』 『U』 『V』 『W』 『X』 『Y』 『Z』',
    fontDigits: '『0』 『1』 『2』 『3』 『4』 『5』 『6』 『7』 『8』 『9』',
  },
  {
    fontName: 'Windy',
    fontLower:
      '≋a≋ ≋b≋ ≋c≋ ≋d≋ ≋e≋ ≋f≋ ≋g≋ ≋h≋ ≋i≋ ≋j≋ ≋k≋ ≋l≋ ≋m≋ ≋n≋ ≋o≋ ≋p≋ ≋q≋ ≋r≋ ≋s≋ ≋t≋ ≋u≋ ≋v≋ ≋w≋ ≋x≋ ≋y≋ ≋z≋',
    fontUpper:
      '≋A≋ ≋B≋ ≋C≋ ≋D≋ ≋E≋ ≋F≋ ≋G≋ ≋H≋ ≋I≋ ≋J≋ ≋K≋ ≋L≋ ≋M≋ ≋N≋ ≋O≋ ≋P≋ ≋Q≋ ≋R≋ ≋S≋ ≋T≋ ≋U≋ ≋V≋ ≋W≋ ≋X≋ ≋Y≋ ≋Z≋',
    fontDigits: '≋0≋ ≋1≋ ≋2≋ ≋3≋ ≋4≋ ≋5≋ ≋6≋ ≋7≋ ≋8≋ ≋9≋',
  },
  {
    fontName: 'PrintStamp',
    fontLower:
      '░a░ ░b░ ░c░ ░d░ ░e░ ░f░ ░g░ ░h░ ░i░ ░j░ ░k░ ░l░ ░m░ ░n░ ░o░ ░p░ ░q░ ░r░ ░s░ ░t░ ░u░ ░v░ ░w░ ░x░ ░y░ ░z░',
    fontUpper:
      '░A░ ░B░ ░C░ ░D░ ░E░ ░F░ ░G░ ░H░ ░I░ ░J░ ░K░ ░L░ ░M░ ░N░ ░O░ ░P░ ░Q░ ░R░ ░S░ ░T░ ░U░ ░V░ ░W░ ░X░ ░Y░ ░Z░',
    fontDigits: '░0░ ░1░ ░2░ ░3░ ░4░ ░5░ ░6░ ░7░ ░8░ ░9░',
  },
  {
    fontName: 'Brackets3',
    fontLower:
      '[̲̅a] [̲̅b] [̲̅c] [̲̅d] [̲̅e] [̲̅f] [̲̅g] [̲̅h] [̲̅i] [̲̅j] [̲̅k] [̲̅l] [̲̅m] [̲̅n] [̲̅o] [̲̅p] [̲̅q] [̲̅r] [̲̅s] [̲̅t] [̲̅u] [̲̅v] [̲̅w] [̲̅x] [̲̅y] [̲̅z]',
    fontUpper:
      '[̲̅A] [̲̅B] [̲̅C] [̲̅D] [̲̅E] [̲̅F] [̲̅G] [̲̅H] [̲̅I] [̲̅J] [̲̅K] [̲̅L] [̲̅M] [̲̅N] [̲̅O] [̲̅P] [̲̅Q] [̲̅R] [̲̅S] [̲̅T] [̲̅U] [̲̅V] [̲̅W] [̲̅X] [̲̅Y] [̲̅Z]',
    fontDigits: '[̲̅0] [̲̅1] [̲̅2] [̲̅3] [̲̅4] [̲̅5] [̲̅6] [̲̅7] [̲̅8] [̲̅9]',
  },
  {
    fontName: 'Fireworks',
    fontLower:
      'a҉ ҉b҉ ҉c҉ ҉d҉ ҉e҉ ҉f҉ ҉g҉ ҉h҉ ҉i҉ ҉j҉ ҉k҉ ҉l҉ ҉m҉ ҉n҉ ҉o҉ ҉p҉ ҉q҉ ҉r҉ ҉s҉ ҉t҉ ҉u҉ ҉v҉ ҉w҉ ҉x҉ ҉y҉ ҉z҉',
    fontUpper:
      '҉A҉ ҉B҉ ҉C҉ ҉D҉ ҉E҉ ҉F҉ ҉G҉ ҉H҉ ҉I҉ ҉J҉ ҉K҉ ҉L҉ ҉M҉ ҉N҉ ҉O҉ ҉P҉ ҉Q҉ ҉R҉ ҉S҉ ҉T҉ ҉U҉ ҉V҉ ҉W҉ ҉X҉ ҉Y҉ ҉Z҉',
    fontDigits: '҉0҉ ҉1҉ ҉2҉ ҉3҉ ҉4҉ ҉5҉ ҉6҉ ҉7҉ ҉8҉ ҉9҉',
  },
  {
    fontName: 'Curvy',
    fontLower: 'ᗩ ᗷ ᑕ ᗪ E ᖴ G ᕼ I ᒍ K ᒪ ᗰ ᑎ O ᑭ ᑫ ᖇ ᔕ T ᑌ ᐯ ᗯ ᙭ Y ᘔ',
    fontUpper: 'ᗩ ᗷ ᑕ ᗪ E ᖴ G ᕼ I ᒍ K ᒪ ᗰ ᑎ O ᑭ ᑫ ᖇ ᔕ T ᑌ ᐯ ᗯ ᙭ Y ᘔ',
    fontDigits: '0 1 2 3 4 5 6 7 8 9',
  },
  {
    fontName: 'Hyphened1',
    fontLower: 'a̶ ̶b̶ ̶c̶ ̶d̶ ̶e̶ ̶f̶ ̶g̶ ̶h̶ ̶i̶ ̶j̶ ̶k̶ ̶l̶ ̶m̶ ̶n̶ ̶o̶ ̶p̶ ̶q̶ ̶r̶ ̶s̶ ̶t̶ ̶u̶ ̶v̶ ̶w̶ ̶x̶ ̶y̶ ̶z̶',
    fontUpper: '̶A̶ ̶B̶ ̶C̶ ̶D̶ ̶E̶ ̶F̶ ̶G̶ ̶H̶ ̶I̶ ̶J̶ ̶K̶ ̶L̶ ̶M̶ ̶N̶ ̶O̶ ̶P̶ ̶Q̶ ̶R̶ ̶S̶ ̶T̶ ̶U̶ ̶V̶ ̶W̶ ̶X̶ ̶Y̶ ̶Z̶',
    fontDigits: '̶0̶ ̶1̶ ̶2̶ ̶3̶ ̶4̶ ̶5̶ ̶6̶ ̶7̶ ̶8̶ ̶9̶',
  },
  {
    fontName: 'Hyphened2',
    fontLower: 'a̴ ̴b̴ ̴c̴ ̴d̴ ̴e̴ ̴f̴ ̴g̴ ̴h̴ ̴i̴ ̴j̴ ̴k̴ ̴l̴ ̴m̴ ̴n̴ ̴o̴ ̴p̴ ̴q̴ ̴r̴ ̴s̴ ̴t̴ ̴u̴ ̴v̴ ̴w̴ ̴x̴ ̴y̴ ̴z̴',
    fontUpper: '̴A̴ ̴B̴ ̴C̴ ̴D̴ ̴E̴ ̴F̴ ̴G̴ ̴H̴ ̴I̴ ̴J̴ ̴K̴ ̴L̴ ̴M̴ ̴N̴ ̴O̴ ̴P̴ ̴Q̴ ̴R̴ ̴S̴ ̴T̴ ̴U̴ ̴V̴ ̴W̴ ̴X̴ ̴Y̴ ̴Z̴',
    fontDigits: '̴0̴ ̴1̴ ̴2̴ ̴3̴ ̴4̴ ̴5̴ ̴6̴ ̴7̴ ̴8̴ ̴9̴',
  },
  {
    fontName: 'Hyphened3',
    fontLower: 'a̷ ̷b̷ ̷c̷ ̷d̷ ̷e̷ ̷f̷ ̷g̷ ̷h̷ ̷i̷ ̷j̷ ̷k̷ ̷l̷ ̷m̷ ̷n̷ ̷o̷ ̷p̷ ̷q̷ ̷r̷ ̷s̷ ̷t̷ ̷u̷ ̷v̷ ̷w̷ ̷x̷ ̷y̷ ̷z̷',
    fontUpper: '̷A̷ ̷B̷ ̷C̷ ̷D̷ ̷E̷ ̷F̷ ̷G̷ ̷H̷ ̷I̷ ̷J̷ ̷K̷ ̷L̷ ̷M̷ ̷N̷ ̷O̷ ̷P̷ ̷Q̷ ̷R̷ ̷S̷ ̷T̷ ̷U̷ ̷V̷ ̷W̷ ̷X̷ ̷Y̷ ̷Z̷',
    fontDigits: '̷0̷ ̷1̷ ̷2̷ ̷3̷ ̷4̷ ̷5̷ ̷6̷ ̷7̷ ̷8̷ ̷9̷',
  },
  {
    fontName: 'Hyphened4',
    fontLower: 'a̲ ̲b̲ ̲c̲ ̲d̲ ̲e̲ ̲f̲ ̲g̲ ̲h̲ ̲i̲ ̲j̲ ̲k̲ ̲l̲ ̲m̲ ̲n̲ ̲o̲ ̲p̲ ̲q̲ ̲r̲ ̲s̲ ̲t̲ ̲u̲ ̲v̲ ̲w̲ ̲x̲ ̲y̲ ̲z̲',
    fontUpper: '̲A̲ ̲B̲ ̲C̲ ̲D̲ ̲E̲ ̲F̲ ̲G̲ ̲H̲ ̲I̲ ̲J̲ ̲K̲ ̲L̲ ̲M̲ ̲N̲ ̲O̲ ̲P̲ ̲Q̲ ̲R̲ ̲S̲ ̲T̲ ̲U̲ ̲V̲ ̲W̲ ̲X̲ ̲Y̲ ̲Z̲',
    fontDigits: '̲0̲ ̲1̲ ̲2̲ ̲3̲ ̲4̲ ̲5̲ ̲6̲ ̲7̲ ̲8̲ ̲9̲',
  },
  {
    fontName: 'Hyphened5',
    fontLower: 'a̳ ̳b̳ ̳c̳ ̳d̳ ̳e̳ ̳f̳ ̳g̳ ̳h̳ ̳i̳ ̳j̳ ̳k̳ ̳l̳ ̳m̳ ̳n̳ ̳o̳ ̳p̳ ̳q̳ ̳r̳ ̳s̳ ̳t̳ ̳u̳ ̳v̳ ̳w̳ ̳x̳ ̳y̳ ̳z̳',
    fontUpper: 'A̳ ̳B̳ ̳C̳ ̳D̳ ̳E̳ ̳F̳ ̳G̳ ̳H̳ ̳I̳ ̳J̳ ̳K̳ ̳L̳ ̳M̳ ̳N̳ ̳O̳ ̳P̳ ̳Q̳ ̳R̳ ̳S̳ ̳T̳ ̳U̳ ̳V̳ ̳W̳ ̳X̳ ̳Y̳ ̳Z̳',
    fontDigits: '̳0̳ ̳1̳ ̳2̳ ̳3̳ ̳4̳ ̳5̳ ̳6̳ ̳7̳ ̳8̳ ̳9̳',
  },
  {
    fontName: 'Bandaid',
    fontLower: 'a͓̽ ͓̽b͓̽ ͓̽c͓̽ ͓̽d͓̽ ͓̽e͓̽ ͓̽f͓̽ ͓̽g͓̽ ͓̽h͓̽ ͓̽i͓̽ ͓̽j͓̽ ͓̽k͓̽ ͓̽l͓̽ ͓̽m͓̽ ͓̽n͓̽ ͓̽o͓̽ ͓̽p͓̽ ͓̽q͓̽ ͓̽r͓̽ ͓̽s͓̽ ͓̽t͓̽ ͓̽u͓̽ ͓̽v͓̽ ͓̽w͓̽ ͓̽x͓̽ ͓̽y͓̽ ͓̽z͓̽',
    fontUpper: '͓̽A͓̽ ͓̽B͓̽ ͓̽C͓̽ ͓̽D͓̽ ͓̽E͓̽ ͓̽F͓̽ ͓̽G͓̽ ͓̽H͓̽ ͓̽I͓̽ ͓̽J͓̽ ͓̽K͓̽ ͓̽L͓̽ ͓̽M͓̽ ͓̽N͓̽ ͓̽O͓̽ ͓̽P͓̽ ͓̽Q͓̽ ͓̽R͓̽ ͓̽S͓̽ ͓̽T͓̽ ͓̽U͓̽ ͓̽V͓̽ ͓̽W͓̽ ͓̽X͓̽ ͓̽Y͓̽ ͓̽Z͓̽',
    fontDigits: '͓̽0͓̽ ͓̽1͓̽ ͓̽2͓̽ ͓̽3͓̽ ͓̽4͓̽ ͓̽5͓̽ ͓̽6͓̽ ͓̽7͓̽ ͓̽8͓̽ ͓̽9͓̽',
  },
  {
    fontName: 'Crossy',
    fontLower: 'a͎ ͎b͎ ͎c͎ ͎d͎ ͎e͎ ͎f͎ ͎g͎ ͎h͎ ͎i͎ ͎j͎ ͎k͎ ͎l͎ ͎m͎ ͎n͎ ͎o͎ ͎p͎ ͎q͎ ͎r͎ ͎s͎ ͎t͎ ͎u͎ ͎v͎ ͎w͎ ͎x͎ ͎y͎ ͎z͎',
    fontUpper: '͎A͎ ͎B͎ ͎C͎ ͎D͎ ͎E͎ ͎F͎ ͎G͎ ͎H͎ ͎I͎ ͎J͎ ͎K͎ ͎L͎ ͎M͎ ͎N͎ ͎O͎ ͎P͎ ͎Q͎ ͎R͎ ͎S͎ ͎T͎ ͎U͎ ͎V͎ ͎W͎ ͎X͎ ͎Y͎ ͎Z͎',
    fontDigits: '͎0͎ ͎1͎ ͎2͎ ͎3͎ ͎4͎ ͎5͎ ͎6͎ ͎7͎ ͎8͎ ͎9͎',
  },
];

export const referenceLower = 'abcdefghijklmnopqrstuvwxyz'; // a b c d e f g h i j k l m n o p q r s t u v w x y z
export const referenceUpper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'; // A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
export const referenceDigits = '0123456789'; // 0 1 2 3 4 5 6 7 8 9

export const generateByFont = (font: any, text: string) => {
  let _converted = '';
  for (const _char of text) {
    if (referenceLower.includes(_char)) {
      // if character is lowercase
      const index = referenceLower.indexOf(_char);
      const fontsArr = font.fontLower.split(' ');
      _converted += fontsArr[index];
    } else if (referenceUpper.includes(_char)) {
      // if character is uppercase
      const index = referenceUpper.indexOf(_char);
      const fontsArr = font.fontUpper.split(' ');
      _converted += fontsArr[index];
    } else if (referenceDigits.includes(_char)) {
      // if character is digit
      const index = referenceDigits.indexOf(_char);
      const fontsArr = font.fontDigits.split(' ');
      _converted += fontsArr[index] || index;
    } else {
      _converted += _char;
    }
  }
  return _converted;
};
